import "rxjs/add/operator/map";

import {Injectable} from "@angular/core";
import {Observable} from "rxjs/Observable";
import {ILoadChunkResult, ISearchItem} from "../definitions";
import {LoaderService} from "./loader.service";
import {ILoaderParams} from "./loader-service-impl/ILoaderParams";
import {IDocument} from "../interfaces/document.definition";

@Injectable()
export class CollectionService extends LoaderService {
  loadChunk(params: ILoaderParams) {
    return this.sendPost(params.createEndpointUrl("/loadChunk"), params.getBody())
      .map(r => <ILoadChunkResult>r.json());
  }


  loadChunkAndAssertOne(params: ILoaderParams): Observable<IDocument> {
    return this.loadChunk(params)
      .map((r: ILoadChunkResult): IDocument => {
        if (r.documents.length !== 1) {
          throw new Error(`Expected only one document with type!`);
        }
        return r.documents[0];
      });
  }


  loadChunkCached(params: ILoaderParams): Observable<ILoadChunkResult> {
    return this.sendPostAndCache(params.createEndpointUrl("/loadChunk"), params.getBody())
      .map(r => <ILoadChunkResult>r.json());
  }


  search(params: ILoaderParams): Observable<ISearchItem[]> {
    let url = params.createEndpointUrl("/search");
    let body = params.getBody();
    //console.log(`url ${url}, body ${JSON.stringify(body)}`)
    return this.sendPost(url, body)
      .map(r => <ISearchItem[]>r.json());
  }


  loadOne(params: ILoaderParams): Observable<IDocument> {
    return this.sendPost(params.createEndpointUrl("/loadOne"), params.getBody())
      .map(r => <IDocument>r.json())
  }


  saveDocument(params: ILoaderParams, document: IDocument) {
    return this.sendPost(params.createEndpointUrl("/updateOne"), document)
      .map(r => true);
  }


  removeDocument(params: ILoaderParams) {
    return this.sendPost(params.createEndpointUrl("/removeOne"), params.getBody())
      .map(r => true);
  }


  createOne(params: ILoaderParams): Observable<any> {
    return this.sendPost(params.createEndpointUrl("/createOne"), params.getBody())
      .map(r => {
        this.preloaderService.hide();
        return r.json();
      });
  }


  duplicate(params: ILoaderParams) {
    return this.sendPost(params.createEndpointUrl("/duplicate"), params.getBody())
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/services/collection.service.ts